import dayjs from "dayjs";
import { Card, CardContent, CardHeader } from "@volca/ui/components/ui/card";
import { Heading, Text } from "@volca/ui/components/ui/text";
import { ChangelogContent } from "./changelog-content";
import type { ChangelogEntry } from "./entries";

export const ChangelogEntryCard = ({ entry }: { entry: ChangelogEntry }) => (
  <article
    id={entry.id}
    aria-labelledby={`${entry.id}-title`}
    className="scroll-mt-6"
  >
    <Card>
      <CardHeader>
        <Text
          variant="caption"
          tone="muted"
          render={<time dateTime={entry.date} />}
        >
          {dayjs(entry.date).format("MMMM D, YYYY")}
        </Text>
        <Heading level={2} id={`${entry.id}-title`}>
          {entry.title}
        </Heading>
      </CardHeader>
      <CardContent>
        <ChangelogContent html={entry.body_html} />
      </CardContent>
    </Card>
  </article>
);
